<template>
  <div id="address-form">
    <section>
      <section class='columns'>
        <div class="column">
          <div class="field">
            <label class="label">ที่อยู่</label>
            <div class="control">
              <input class="input" type="text" placeholder="ที่อยู่" v-model="formData.address">
            </div>
          </div>
        </div>
      </section>

      <section class="columns">
        <div class="column">
          <div class="field">
            <label class="label">อำเภอ/เขต</label>
            <div class="control">
              <input class="input" type="text" placeholder="อำเภอ/เขต" v-model="formData.district">
            </div>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">ตำบล/แขวง</label>
            <div class="control">
              <input class="input" type="text" placeholder="ตำบล/แขวง" v-model="formData.subDistrict">
            </div>
          </div>
        </div>
      </section>

      <section class="columns">
        <div class="column">
          <div class="field">
            <label class="label">จังหวัด</label>
            <div class="control">
              <input class="input" type="text" placeholder="จังหวัด" v-model="formData.province">
            </div>
          </div>
        </div>

        <div class="column">
          <div class="field">
            <label class="label">รหัสไปรษณีย์</label>
            <div class="control">
              <input class="input" type="text" placeholder="รหัสไปรษณีย์" v-model="formData.postalCode">
            </div>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
    export default {
        name: "AddressForm",
        data: function () {
            return {
                formData: {}
            }
        },
        methods: {},
        watch: {
            userFormDataState(newFormState) {
                this.formData = newFormState;
            },
            async formValue() {
                await this.$store.dispatch('setUserFormData', this.formData);
            }
        },
        computed: {
            formValue() {
                return Object.values(this.formData);
            },
            userFormDataState() {
                return this.$store.getters.userFormData;
            }
        }
    }
</script>

<style scoped>

</style>
